/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-09-01 21:20:48
 * @LastEditors: Betway
 * @LastEditTime: 2026-06-18 14:21:53
 * @FilePath: \mrc-base-server-view\src\service\baseUrl.js
 */
/**
 * 是否本地開發環境
 * 判斷是否開啓代理
 */
const isLocal = () => location.host.includes("localhost")

// const baseUrl = process.env.VUE_APP_BASE_URL //独立版本部署打开这个，打包完之后关闭
const baseUrl = isLocal() ? process.env.VUE_APP_BASE_URL : businessUrl
export default baseUrl
